<template>
  <div>
    <van-pull-refresh :disabled="refreshingFlag" v-model="refreshing" @refresh="onRefreshs" success-text="刷新成功">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
      >
        <vanCollapseContent :list = list ></vanCollapseContent>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import vanCollapseContent from './BalanceVanCollapseContent.vue'
import { profitList } from '@/api/user.js'
export default {
  components: { vanCollapseContent },
  props: {
    paramsList: {
      type: Object
    },
    list: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      finishedText: '没有更多流水账单了',
      // 刷新节流阀
      refreshingFlag: false,
      newList: []
    }
  },
  watch: {},
  computed: {},
  methods: {
    async onLoad () {
      const { data: res } = await profitList(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      // res.extend.rows.forEach(item => {
      //   item.createTime = item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0]
      // })
      this.newList = res.extend.rows
      this.$emit('change', {
        list: this.newList,
        type: 'add'
      })
      this.loading = false
      if (res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      } else {
        this.finished = true
      }
      this.refreshing = false
      this.$nextTick(_ => {
        this.refreshingFlag = false
      })
    },
    onRefreshs () {
      this.refreshingFlag = true
      // 清空列表数据
      this.finished = false
      this.$emit('change', {
        list: [],
        type: 'refresh'
      })
      this.paramsList.page = 1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  .nones {
    /deep/.van-step__circle-container {
      display: none;
    }
    /deep/.van-step__line {
      display: none;
    }
  }
  /deep/.van-step__title {
    .stepHThree {
      margin-bottom: 15px;
    }
  }
</style>
